import "./styles.css";
import { initGame } from "./js/game";

initGame();
